import angular from 'angular';
import ngCache from 'angular-cache';

import Model from './model';
import AnalyticsServ from '../services/analytics';
import ReloadServ from '../services/reload';

function UserFactory(Model, AnalyticsServ, $cacheFactory, $window, ReloadServ) {
  return class UserModel extends Model {
    constructor(data = {}) {
      super(data);

      this.setApi('/user', null, {
        get: {
          method: 'GET',
          cache: true
        },
        fetch: {
          method: 'GET',
          params: {
            registered: true
          }
        },
        update: {
          method: 'PUT',
          success: [
            data => $cacheFactory.get('$http').remove('/user'),
            data => this.success(data),
            data => AnalyticsServ.updated('User')
          ]
        },
        signin: {
          method: 'POST',
          url: '/login',
          params: {
            rememberMe: '@rememberMe'
          },
          success: [
            data => this.success(data),
            data => {
              ReloadServ.updateTabs();
              AnalyticsServ.signedIn(data)
            }
          ]
        },
        signup: {
          method: 'POST',
          url: '/signup',
          success: [
            data => this.success(data),
            data => AnalyticsServ.signedUp(data)
          ]
        },
        signout: {
          method: 'POST',
          url: '/logout',
          success: [
            data => this.success(data), () => {
              $cacheFactory.get('$http').remove('/user');
              AnalyticsServ.signedOut();
              ReloadServ.updateTabs();
              $window.location.href = "/";
            }
          ]
        },
        changePassword: {
          method: 'POST',
          url: '/user/changePassword',
          success: [
            data => this.success(data),
            data => AnalyticsServ.updated('Password')
          ]
        },
        resetPassword: {
          method: 'POST',
          url: '/user/reset',
          fail: [
            () => this.data.password = '',
            data => this.fail(data)
          ]
        },
        initPassword: {
          method: 'POST',
          url: '/user/init',
          fail: [
            () => this.data.password = '',
            data => this.fail(data)
          ]
        },
        requestReset: {
          method: 'POST',
          url: '/user/requestReset',
          params: {
            email: '@email'
          },
          success: [
            data => this.success(data),
            data => AnalyticsServ.analytics.track(
              'Password Reset Requested')
          ],
          fail: [
            () => this.data.email = '',
            data => this.fail(data)
          ]
        },
        changeAccount: {
          method: 'PUT',
          url: '/user/account/:accountId',
          params: {
            accountId: '@accountId'
          },
          success: [
            data => $cacheFactory.get('$http').remove('/user'),
            data => this.success(data),
            data => ReloadServ.updateTabs()
          ]
        },
        verify: {
          method: 'PUT',
          url: '/user/verify',
          success: [
            data => $cacheFactory.get('$http').remove('/user'),
            data => this.success(data),
            data => AnalyticsServ.userVerified(data)
          ],
        },
        addPhone: {
          method: 'POST',
          url: '/user/mfa'
        },
        removePhone: {
          method: 'PUT',
          url: '/user/mfa',
          success: [
            data => $cacheFactory.get('$http').remove('/user'),
            data => AnalyticsServ.userMfaDisabled(this.data)
          ],
        },
        sendSMS: {
          method: 'GET',
          url: '/user/mfa/verify'
        },
        verifyAuthCode: {
          method: 'POST',
          url: '/user/mfa/verify',
          success: [
            data => $cacheFactory.get('$http').remove('/user'),
            data => AnalyticsServ.userMfaEnabled(this.data)
          ],
        },
        purchaseCase: {
          method: 'PUT',
          url: '/user/pay-for',
          params: {
            caseId: '@caseId'
          }
        },
        queryInviter: {
          method: 'GET',
          url: '/invite/:id',
          params: {
            id: '@id'
          },
          success: [data => {
            this.data.referredBy = data.referrerCode;
            this.setData();
          }]
        },
        invite: {
          method: 'POST',
          url: '/invite',
          success: [
            data => AnalyticsServ.analytics.track('Referrals Sent')
          ]
        },
      });
    }
  }
}

UserFactory.$inject = ['Model', 'AnalyticsServ', '$cacheFactory', '$window',
  'ReloadServ'
];

export default angular.module('models.user', [Model, AnalyticsServ, ReloadServ,
    ngCache
  ])
  .factory('User', UserFactory)
  .service('CurrentUser', ['User', User => new User()])
  .name;



// WEBPACK FOOTER //
// ./project/models/user.js